import DataRow from '@components/DataRow'
import { formatMoney, tr } from 'mmfintech-commons'

import './MerchantPane.scss'

type MerchantPaneProps = {
  session: any
  logo?: string
}

export const MerchantPane = ({ session, logo }: MerchantPaneProps) => {
  if (session) {
    const { amount, currency, foreignTransactionId, merchantName } = session || {}

    return (
      <div className='merchant-pane-wrapper'>
        <div className='amount-container'>
          <div className='logo-container'>
            <div>
              <div className='label'>{tr('CHECKOUT.PAYMENT.AMOUNT', 'Amount')}</div>
              <div className='value'>{formatMoney(amount, currency)}</div>
            </div>
            {logo && <img className='logo' src={logo} alt='' />}
          </div>
        </div>
        <div className='main-container'>
          <DataRow label={tr('CHECKOUT.PAYMENT.PAY_TO', 'Pay to')} value={merchantName} />
          <DataRow label={tr('CHECKOUT.PAYMENT.TRANSACTION_ID', 'Transaction ID')} value={foreignTransactionId} />
        </div>
      </div>
    )
  }

  return null
}
